<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Add safes transfers')"
          :description="$t('From here you can create a new transfers')"
          v-if="$route.name == 'safesTransfersCreate'"
        />
        <addHeader
          :title="$t('Safes transfers adjustment')"
          :description="$t('From here you can modify the sales payment information')"
          v-if="$route.name == 'safesTransfersEdit'"
        />

        <div class="mb-4 row">
          <connectionInput
            :title="$t('Numbering the transfer')"
            :group="$t('Groups')"
            v-model="item.invoice_group"
            :disabled="$checkRole('sales_payments_edit_item') ? false : true"
            :values="$database.invoiceGroups"
            v-if="$route.name == 'safesTransfersCreate'"
            :hasErorr="errors.invoice_group"
            :error="$t('Numbering is required')"
          />
          <formInput
            :title="$t('Operation code')"
            v-model="item.code"
            :disabled="true"
            v-if="$route.name == 'safesTransfersEdit'"
            maxlength="255"
          />

          <subFileInput
            :title="$t('Invoice file')"
            v-model="item.file"
            :file="item.file"
            :path="'invoices'"
            :hasErorr="errors.file"
            :error="$t('Choose A SuitableFile')"
          />
          <formInput :title="$t('Reference')" v-model="item.refrance" maxlength="255" />

          <div class="form-group row" :class="'col-md-6'">
            <label :class="'col-md-4'">{{ $t('Withdrawal date') }}</label>
            <div :class="'col-md-7'">
              <div class="icon-input w-100 to-left">
                <span><i class="far fa-calendar"></i></span>
                <VueCtkDateTimePicker
                  :label="$t('Choose time and date')"
                  :button-now-translation="$t('Now')"
                  v-model="item.date"
                  :disabled="$checkRole('sales_payments_edit_item') ? false : true"
                  format="YYYY-MM-DD hh:mm a"
                  color="#631263"
                  button-color="#631263"
                />
              </div>
            </div>
          </div>

          <connectionInput
            :title="$t('From safe')"
            group="الخزائن"
            v-model="item.from_safe_id"
            :values="$database.safes"
            :hasErorr="errors.from_safe_id"
            :error="$t('This field is required')"
          />
          <connectionInput
            :title="$t('To safe')"
            group="الخزائن"
            v-model="item.to_safe_id"
            :values="$database.safes"
            :hasErorr="errors.to_safe_id"
            :except="item.from_safe_id"
            :error="$t('This field is required')"
          />

          <selectInput
            :title="$t('Situation')"
            v-model="item.status"
            :values="[
              { name: $t('Draft'), value: 0 },
              { name: $t('Approved'), value: 1 }
            ]"
          />

          <checkInput
            :title="$t('Print the invoice')"
            :value="print"
            v-model="print"
            v-if="$route.name == 'safesWithdrawalsCreate'"
          />

          <dvider
            :title="$t('Accounts information')"
            :description="$t('Account information details')"
          />

          <monyInput
            :title="$t('Received amount')"
            v-model="item.cost"
            :hasErorr="errors.cost"
            :error="$t('The amount received must be greater than')"
          />

          <connectionInput
            :title="$t('Payment method')"
            :group="$t('Payment methods')"
            v-model="item.payment_method_id"
            :hasAdd="true"
            :open="'addPaymentMethod'"
            :values="$database.paymentMethods"
            :value="item.payment_fee_id"
            :disabled="$checkRole('sales_payments_edit_item') ? false : true"
          />

          <dvider :title="$t('Payment notes')" :description="$t('Payment notes details')" />

          <formTextarea :title="$t('That about')" v-model="item.description" />
          <formTextarea :title="$t('Note')" v-model="item.notes" />
          <hr class="mt-5 mb-5 col-12" />
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'safesTransfersCreate' && !$parent.stopEdit"
          >
            {{ $t('Add safes transfers') }}
          </a>
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'safesTransfersEdit' && !$parent.stopEdit"
          >
            {{ $t('Edit safes transfers') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import formTextarea from '@/elements/add/form/formTextarea.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import monyInput from '@/elements/add/form/monyInput.vue'
import selectInput from '@/elements/add/form/selectInput.vue'
import checkInput from '@/elements/add/form/checkInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import subFileInput from '@/elements/add/form/subFileInput.vue'

import searchGroupInput from '@/elements/add/form/searchGroupInput.vue'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  data() {
    return {
      path: '/safesTransfers',
      item: {
        invoice_group: this.$option.safes_transfer_invoice_group_id,
        payment_method_id: 0,
        from_safe_id: '',
        to_safe_id: '',
        date: '',
        status: 1,
        from_safe: {},
        to_safe: {}
      },
      selectedPaymentFees: [],
      model: false,
      errors: {
        invoice_group: false,
        cost: false,
        from_safe_id: false,
        to_safe_id: false
      },
      print: this.$route.name == 'safesTransfersCreate' ? true : false
    }
  },
  mounted() {
    this.$updateDatabase(['invoiceGroups', 'safes', 'paymentMethods'])

    if (this.$route.name == 'safesTransfersEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    } else {
      var params = this.$getParams()
      if (params.from_safe_id) {
        this.item.from_safe_id = params.from_safe_id
      }
      if (params.to_safe_id) {
        this.item.to_safe_id = params.to_safe_id
      }
    }
    if (this.$route.name == 'safesTransfersCreate') {
      var params = this.$getParams()
      if (params.from_safe_id) {
        var safe = this.$database.safes.find((el) => el.id == params.from_safe_id)
        this.item.from_safe_id = params.from_safe_id
        this.item.safe = safe
      }

      if (params.point_of_sale_id) {
        this.item.point_of_sale_id = params.point_of_sale_id
      }
      if (params.session_number) {
        this.item.session_number = params.session_number
      }

      this.item.date = this.$nowDate()
    }

    var elm = this
    window.addEventListener('keydown', function (e) {
      if (e.key == 'F1' || e.key == 'Meta') {
        e.preventDefault()
        elm.saveItem()
      }
    })
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
        this.item.date = this.$dateFormat(this.item.date, true)
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.cost === 'undefined' || this.item.cost == '' || this.item.cost == 0) {
        error = 1
        this.errors.cost = true
      }

      if (
        (typeof this.item.invoice_group === 'undefined' ||
          this.item.invoice_group == 0 ||
          this.item.invoice_group == '' ||
          this.item.invoice_group == null) &&
        this.$route.name == 'safesTransfersCreate'
      ) {
        error = 1
        this.errors.invoice_group = true
      }
      if (this.$route.name == 'safesTransfersCreate') {
        if (
          typeof this.item.to_safe_id === 'undefined' ||
          this.item.to_safe_id == '' ||
          this.item.to_safe_id == 0
        ) {
          error = 1
          this.errors.to_safe_id = true
        }
        if (
          typeof this.item.from_safe_id === 'undefined' ||
          this.item.from_safe_id == '' ||
          this.item.from_safe_id == 0
        ) {
          error = 1
          this.errors.from_safe_id = true
        }
      }
      const from_safe = this.$database.safes.find((el) => el.id == this.item.from_safe_id)
      if (this.item.cost > from_safe.balance) {
        error = 1
      }
      if (error == 0) {
        this.item.date = this.$fixDate(this.item.date)
        if (this.$route.name == 'safesTransfersCreate') {
          this.$toast.success(this.$t('Safes Transfers Successfully Added'))
          const invoiceGroup = this.$database.invoiceGroups.find(
            (invoiceGroup) => invoiceGroup.id === this.item.invoice_group
          )

          this.item.code = invoiceGroup.prefix
          this.$addToLocalDatabase(this.item, this.path.substring(1))
          this.item.new_balance = parseFloat(this.item.old_balance) + parseFloat(this.item.cost)

          //change safes balance
          var fromSafe = this.$database.safes.find((el) => el.id == this.item.from_safe_id)
          if (fromSafe) {
            fromSafe.balance = parseFloat(fromSafe.balance) - parseFloat(this.item.cost)
          }
          var toSafe = this.$database.safes.find((el) => el.id == this.item.to_safe_id)
          if (toSafe) {
            toSafe.balance = parseFloat(toSafe.balance) + parseFloat(this.item.cost)
          }

          localStorage.database = JSON.stringify(this.$database)
          this.$router.go(-1)
          this.$parent.stopEdit = false
        } else if (this.$route.name == 'safesTransfersEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              this.$toast.success(this.$t('safe Transfers Has Been Modified Successfully'))
              this.$router.go(-1)
              this.$parent.stopEdit = false
              return response
            })
        }
      } else {
        this.$toast.error(
          this.item.cost > from_safe.balance
            ? this.$t('the balance of the safe not enough')
            : this.$t('please Make Sure Of The Input')
        )
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  components: {
    formInput,
    dvider,
    addHeader,
    monyInput,
    selectInput,
    formTextarea,
    connectionInput,
    checkInput,
    loading,
    subFileInput,
    searchGroupInput,
    VueCtkDateTimePicker
  }
}
</script>
